module.exports = __webpack_public_path__ + "static/media/phoenix_on_dark_256.12fbef24.png";